import React from 'react';
import { useParams } from 'react-router-dom';
import workout1 from '../../Assets/images/Services/workout1.jpeg';
import workout2 from '../../Assets/images/Services/workout2.jpeg';
import workout3 from '../../Assets/images/Services/workout3.jpeg';
import workout4 from '../../Assets/images/Services/workout4.jpeg';
import { Grid2 } from '@mui/material';

const allServiceData = [
  {
    title: 'XFit',
    description:
      "Unlock your full potential with our XFit program. Our expert coaches will guide you through a series of high-intensity workouts designed to improve your strength, endurance, and agility. Whether you're a beginner or an experienced athlete, our XFit program will challenge you to reach new heights.",
    image: workout1,
    benefits: [
      'Improved cardiovascular endurance',
      'Increased strength and muscle tone',
      'Enhanced flexibility and mobility',
      'Weight loss and improved body composition'
    ]
  },
  {
    title: 'Personal Training',
    image: workout2,
    description:
      "Take your fitness journey to the next level with our personalized training programs. Our experienced trainers will work with you to create a customized fitness plan tailored to your specific goals and needs. Whether you're looking to lose weight, build muscle, or improve your overall health, our personal training programs will help you achieve your objectives.",
    benefits: [
      'Personalized attention and guidance',
      'Customized fitness plans tailored to your goals and needs',
      'Improved motivation and accountability',
      'Faster results and progress'
    ]
  },
  {
    title: 'Beach Bootcamps',
    image: workout3,
    description:
      'Get fit and have fun with our beach bootcamps! Our expert trainers will lead you through a series of high-energy workouts designed to challenge and motivate you. Enjoy the beautiful scenery and fresh air while you improve your cardiovascular endurance, strength, and agility.',
    benefits: [
      'Improved cardiovascular endurance',
      'Increased strength and muscle tone',
      'Enhanced flexibility and mobility',
      'Weight loss and improved body composition',
      'Fun and motivating workout environment'
    ]
  },
  {
    title: 'Aquatic Fitness',
    image: workout4,
    description:
      'Make a splash with our aquatic fitness programs! Our expert instructors will guide you through a series of low-impact, high-intensity workouts designed to improve your cardiovascular endurance, strength, and flexibility. Enjoy the relaxing and rejuvenating benefits of water-based exercise.',
    benefits: [
      'Low-impact exercise for joints and muscles',
      'Improved cardiovascular endurance',
      'Increased strength and muscle tone',
      'Enhanced flexibility and mobility',
      'Relaxing and rejuvenating workout environment'
    ]
  }
];

const DetailedServices = () => {
  const { id } = useParams();
  const serviceData = allServiceData[id];
  const styles = {
    container: {
      fontFamily: 'Raleway',
      backgroundColor: 'white', // Light blue background
      padding: '20px',
      borderRadius: '10px',
      //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      lineHeight: '1.6',
      height: '100%',
      paddingTop: '70px'
    },
    heading: {
      fontSize: '24px',
      color: '#181818de',
      textAlign: 'center',
      marginBottom: '15px'
    },
    imageContainer: {
      width: '100%', // Container takes full width
      height: '300px', // Fixed height for the container
      overflow: 'hidden' // Ensures no overflow
    },
    image: {
      display: 'block',
      margin: '20px auto',
      width: '100%',
      maxWidth: '300px',
      borderRadius: '10px'
    },
    description: {
      fontSize: '16px',
      color: '#34495e',
      marginBottom: '20px'
    },
    benefitsTitle: {
      fontSize: '18px',
      color: '#2c3e50',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    benefitList: {
      listStyleType: 'disc',
      paddingLeft: '20px',
      color: '#34495e'
    },
    benefitItem: {
      marginBottom: '8px'
    }
  };

  const { title = '', description = '', image, benefits = [] } = serviceData;

  return (
    <div style={styles.container}>
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <img src={image} alt={title} style={styles.image} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <div
            style={{ display: 'flex', alignItems: 'center', height: '100%' }}
          >
            <div>
              <h1 style={styles.heading}>{title}</h1>
              <p style={styles.description}>{description}</p>
            </div>
          </div>
        </Grid2>
      </Grid2>
      {/* <div style={styles.imageContainer}>
        <img src={image} alt={title} style={styles.image} />
      </div>
      <h1 style={styles.heading}>{title}</h1>
      <p style={styles.description}>{description}</p> */}
      <div>
        <p style={styles.benefitsTitle}>Benefits:</p>
        <ul style={styles.benefitList}>
          {benefits.map((benefit, index) => {
            return (
              <li key={`benifit-${index}`} style={styles.benefitItem}>
                {benefit}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DetailedServices;
